import React from "react";
import ConnectedHitsCount from "../ConnectedHitsCount";
import ConnectedSlider from "../ConnectedSlider";
import AttributeSelectionContainer from "../AttributeSelectionContainer";
import ConnectedAutoComplete from "../ConnectedAutoComplete";
import LeadingText from "../LeadingText";
import BaseButton from "../BaseButton";
import FullScreenOverlay from "../FullScreenOverlay";
import ConnectedAttributeRefinementContainer from "../ConnectedAttributeRefinementContainer";
import FloatingActionButton from "../FloatingActionButton";
import { ArrowLeft } from "../Icons";

export default class FilterCardContainer extends React.Component {
  constructor() {
    super();
    this.state = {
      autoCompleteHasFocus: false,
      autoCompleteInputValue: "",
      showOverlay: false,
      selectedRefinement: { label: "", refinement: "" }
    };
  }

  componentDidMount() {
    const { searchState, clearAutoComplete } = this.props;
    if (searchState.query) {
      clearAutoComplete();
    }
  }

  autoCompleteInputChange = value => {
    this.setState({
      autoCompleteInputValue: value
    });
  };

  handleAutoCompleteFocus = () => {
    this.setState({
      autoCompleteHasFocus: true
    });
  };

  handleAutoCompleteBlur = () => {
    this.setState({
      autoCompleteHasFocus: false
    });
  };

  onSelectAttribute = attribute => {
    this.setState({
      showOverlay: true,
      selectedRefinement: attribute
    });
  };

  hideRefinementOverlay = () => {
    this.setState({
      showOverlay: false,
      selectedRefinement: { label: "", refinement: "" }
    });
  };

  renderRefinementOverlay = (showOverlay, selectedRefinement) => {
    const { defaultRefinements } = this.props;
    const { label, refinement } = selectedRefinement;
    return (
      <FullScreenOverlay
        axis="x"
        startingPosition="positive"
        show={showOverlay}
      >
        <div className="w-full h-full bg-grey-lighter px-3 pb-3 relative">
          <div
            style={{
              height: "10%"
            }}
            className="w-full flex items-center justify-between"
          >
            <FloatingActionButton
              bgColor="blue-darker"
              size="xs"
              onClick={() => this.hideRefinementOverlay()}
            >
              <ArrowLeft stroke="white" height="15px" />
            </FloatingActionButton>

            <LeadingText
              textColor="grey-darkest"
              fontWeight="lg"
              textAlign="center"
            >
              {label}
            </LeadingText>
            <div />
          </div>
          <ConnectedAttributeRefinementContainer
            defaultRefinement={defaultRefinements[refinement]}
            attribute={refinement}
            operator="or"
            transformItems={items => items.sort((a, b) => b.label < a.label)}
            limit={20}
          />
        </div>
      </FullScreenOverlay>
    );
  };

  render() {
    const {
      searchState,
      onResetSearchState,
      refinementAttributes,
      defaultRefinements
    } = this.props;

    const {
      autoCompleteHasFocus,
      autoCompleteInputValue,
      showOverlay,
      selectedRefinement
    } = this.state;

    const autoCompleteIsActive =
      autoCompleteHasFocus || autoCompleteInputValue.length > 0;

    return (
      <div
        style={{
          paddingBottom: "60px"
        }}
        className="w-full h-full bg-grey-lighter"
      >
        <div className="w-full h-full overflow-y-scroll overflow-x-auto py-3 px-3">
          <div className="w-full">
            <ConnectedAutoComplete
              maxHeight="500px"
              handleFocus={this.handleAutoCompleteFocus}
              handleBlur={this.handleAutoCompleteBlur}
              onInputChange={this.autoCompleteInputChange}
            />
          </div>
          <div
            className="w-100 h-100 pt-4"
            style={{
              opacity: autoCompleteIsActive ? 0.3 : 1,
              backgroundColor: autoCompleteIsActive ? "white" : "transparent",
              pointerEvents: autoCompleteIsActive ? "none" : "auto"
            }}
          >
            <div className="rounded w-full px-4 bg-white shadow-blur-lg">
              <ConnectedSlider
                attribute="price"
                defaultRefinement={{ ...defaultRefinements.price }}
                _label="Preis"
                _unit="€"
              />
            </div>
            <div className="pt-4">
              <AttributeSelectionContainer
                searchState={searchState}
                attributes={refinementAttributes}
                defaultRefinements={defaultRefinements}
                onSelectAttribute={attribute =>
                  this.onSelectAttribute(attribute)
                }
              />
            </div>
            <div className="pt-4">
              <div className="rounded w-full px-4 bg-white shadow-blur-lg">
                <ConnectedSlider
                  attribute="bridgeWidth"
                  defaultRefinement={{ ...defaultRefinements.bridgeWidth }}
                  _label="Stegweite"
                  _unit="mm"
                />
                <ConnectedSlider
                  attribute="lensWidth"
                  defaultRefinement={{ ...defaultRefinements.lensWidth }}
                  _label="Scheibengröße"
                  _unit="mm"
                />
              </div>
            </div>
          </div>
        </div>
        <div
          className="w-full pin-b pin-l flex items-center justify-center p-3"
          style={{
            height: "60px"
          }}
        >
          <div className="w-2/3 relative h-full flex items-center justify-center bg-teal shadow-lg rounded">
            <ConnectedHitsCount />
          </div>

          <div className="w-1/3 bg-blue-darker text-white h-full ml-2 shadow-lg rounded">
            <BaseButton className="w-full h-full" onClick={onResetSearchState}>
              <LeadingText
                textColor="white"
                textAlign="center"
                fontWeight="normal"
                textSize="xs"
              >
                {"Zurücksetzen".toUpperCase()}
              </LeadingText>
            </BaseButton>
          </div>
        </div>
        {this.renderRefinementOverlay(showOverlay, selectedRefinement)}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/FilterContainer/FilterContainer.js